class GraftIngredientCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-graft-carousel-track]');
    this.prevButton = this.querySelector('[data-graft-carousel-prev]');
    this.nextButton = this.querySelector('[data-graft-carousel-next]');
    this.dialog = this.querySelector('[data-graft-label-dialog]');
    this.dialogImage = this.querySelector('[data-graft-label-dialog-image]');

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.scrollByCard(-1));
    }
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.scrollByCard(1));
    }

    this.querySelectorAll('[data-graft-label-trigger]').forEach((button) => {
      button.addEventListener('click', () => this.openLabel(button));
    });

    if (this.dialog) {
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      const closeButton = this.dialog.querySelector('[data-graft-label-dialog-close]');
      if (closeButton) closeButton.addEventListener('click', () => this.dialog.close());
    }
  }

  scrollByCard(direction) {
    if (!this.track) return;
    const card = this.track.querySelector('[data-graft-carousel-card]');
    const amount = card ? card.getBoundingClientRect().width + 16 : 280;
    this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
  }

  openLabel(button) {
    if (!this.dialog || !this.dialogImage) return;
    const src = button.getAttribute('data-full-src');
    const alt = button.getAttribute('data-full-alt') || '';
    if (!src) return;
    this.dialogImage.setAttribute('src', src);
    this.dialogImage.setAttribute('alt', alt);
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', 'open');
    }
  }
}

customElements.define('graft-ingredient-carousel', GraftIngredientCarousel);
